import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
// import { Tooltip } from 'antd';
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { AiOutlineSearch } from "react-icons/ai";
import { Card, Alert } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import success from "../../assets/img/success.png";
import FileBase64 from "../../components/Upload/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Tooltip from "@mui/material/Tooltip";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';

import { makeStyles } from "@mui/styles";
import { AdminAddLanguages } from '../../redux/actions/adminAddLanguageAction';
import { getLanguageListAdmin } from "../../redux/actions/adminGetLanguageListAction";
import { getLanguageDropListAdmin } from '../../redux/actions/adminGetLanguageDropListAction';
import { adminEditLanguagesList } from '../../redux/actions/adminEditMappingLanguageListAction';
import Util from "../../validation";
import { LocalLaundryService } from '@mui/icons-material';
import addorUpadateBusinessNatureReducer from '../../redux/reducers/addorUpadateBusinessNatureReducer';

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminLanguageMaster = () => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selectedLanguage, setSelectedLanguage] = useState('');

    const [addLanguageName, setAddLanguageName] = useState('');
    const [addLanguageCode, setAddLanguageCode] = useState('');
    const [AddLanguageResp, setAddLanguageResp] = useState(false);
    const [res, setres] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [getLanguageListStatus, setGetLanguageListStatus] = useState(false);
    const [getLanguageListArray, setGetLanguageListArray] = useState([]);   //"" || []
    const [getLanguageDropListStatus, setGetLanguageListDropStatus] = useState(false);
    const [getLanguageListDropArray, setGetLanguageListDropArray] = useState("");
    const [getLanguageName, setetLanguageName] = useState([]);
    const [addOpen, setAddOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [languageList, setLanguageList] = useState([])
    const [editOpen, seteditOpen] = useState(false);
    const [editBankId, setEditBankId] = useState('');
    const [editLanguageName, setEditLanguageName] = useState('');
    const [editLanguageCode, setEditLanguageCode] = useState('');
    const [setAddUpdateResp, setsetAddUpdateResp] = useState(false);
    const [respDescriptionLanguageAddUpdate, setRespDescriptionLanguageAddUpdate] = useState('');


    const classes = useStyles();

    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    // var authToken = regenerateTokenRes.data.AuthToken;
    const authToken = regenerateTokenRes.data?.AuthToken || localStorage.getItem("authToken"); // Assuming you store it in localStorage too
   // State to track if a token regeneration is in progress
    const [isRegeneratingToken, setIsRegeneratingToken] = useState(false);
    const addLanguagesRes = useSelector(({ adminAddLanguagLists }) => adminAddLanguagLists);
    const getLanguageListRes = useSelector(({ adminGetLanguagesLists }) => adminGetLanguagesLists);
    const getLanguagesDropRes = useSelector(({ adminGetLanguagesDropsLists }) => adminGetLanguagesDropsLists);
    const editMappingLanguageRes = useSelector(({ adminEditMappingLanguageLists }) => adminEditMappingLanguageLists);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const dispatch = useDispatch();
    const onInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addLanguageName') {
            // setAddLanguageName(value);
            Util.alphaNumeric(value) ? setAddLanguageName(value) : setAddLanguageName(addLanguageName);
        }
        if (name === 'addLanguageCode') {
            // setAddLanguageCode(value)
            Util.alphaNumeric(value) ? setAddLanguageCode(value) : setAddLanguageCode(addLanguageCode);
        }
        if (name === "selectedLanguage") {
            setSelectedLanguage(value === "Select Language" ? "" : value);
            // console.log('Selected Country: ', value);
        }

    }
    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setRespDescriptionLanguageAddUpdate('');


    }
    const addLanguageModalOpen = () => {
        setAddOpen(true);

        setAddLanguageName('');
        setAddLanguageCode('');
    }
    const handleClose = () => {
        setAddOpen(false);
    }
    const editHandleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editBankId') {
            setEditBankId(value);
        }
        if (name === 'editLanguageName') {
            // setEditLanguageName(value);
            Util.alphaNumeric(value) ? setEditLanguageName(value) : setEditLanguageName(editLanguageName);
        }
        if (name === 'editLanguageCode') {
            // setEditLanguageCode(value)
            Util.alphaNumeric(value) ? setEditLanguageCode(value) : setEditLanguageCode(editLanguageCode);
        }

    }
    const editModal = (id, name, code) => {
        setEditBankId(id);
        setEditLanguageName(name);
        setEditLanguageCode(code);
        seteditOpen(true);
    }
    const closeEditModal = () => {
        seteditOpen(false);
    }

    const editSubmitReq = () => {
        setsetAddUpdateResp(true);
        const editReq = {
            actionCustomerMasterRequestVO: {

                id: editBankId,
                languageName: editLanguageName,
                languageCode: editLanguageCode,



            }
        }
        dispatch(adminEditLanguagesList(editReq, authToken));
        seteditOpen(false);
    }

    const addOrUpdateNewLanguageRespFunc = () => {
        if (setAddUpdateResp) {
            if (editMappingLanguageRes.data.status === 'Success') {
                setRespDescriptionLanguageAddUpdate(editMappingLanguageRes.data.description);
                setnotificationOpen(true);
                adminGetLanguageListReq();



            }
            if (editMappingLanguageRes.data.status === 'failed') {
                setRespDescriptionLanguageAddUpdate(editMappingLanguageRes.data.description);
                setnotificationOpen(true);
                if (
                    editMappingLanguageRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    editMappingLanguageRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (editMappingLanguageRes.data.status === 'Failed') {
                setRespDescriptionLanguageAddUpdate(editMappingLanguageRes.data.description);
                setnotificationOpen(true);
                if (
                    editMappingLanguageRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    editMappingLanguageRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }
    useEffect(() => {
        addOrUpdateNewLanguageRespFunc()
    },[editMappingLanguageRes.data.status]);
   // }, [editMappingLanguageRes.data.status]);

    const getLanguageDropListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"),
                languageName: "",


            }
        }
        dispatch(getLanguageDropListAdmin(req, authToken));
    };


 useEffect(() => {
        if (getLanguagesDropRes.loading === false) { // Check if the API call has completed
            if (getLanguagesDropRes.data?.status === 'success') {
                setIsLoading(false);
                setLanguageList(getLanguagesDropRes.data.customerMasterDetailsRequestVOList);
                setIsRegeneratingToken(false); // Reset regeneration flag on success
            } else if (getLanguagesDropRes.data?.status === 'failed') {
                if (getLanguagesDropRes.data.description === "session out") {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                } else if (getLanguagesDropRes.data.description === "Authorization failed" && !isRegeneratingToken) {
                    // Trigger token regeneration if Authorization failed and not already regenerating
                    setIsRegeneratingToken(true); // Set flag to prevent multiple regeneration calls
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data?.partnerId || localStorage.getItem("walletOwnerId"));
                }
                setIsLoading(false); // Still set loading to false even if failed
            }
        }
    }, [getLanguagesDropRes, dispatch, authToken, regenerateTokenRes.data?.partnerId, isRegeneratingToken]);


        // Effect to re-call getLanguageDropListReq after token regeneration success
    useEffect(() => {
        if (regenerateTokenRes.loading === false && regenerateTokenRes.data?.status === 'success' && isRegeneratingToken) {
            // Token regenerated successfully, now retry the language list call with the new token
            const newAuthToken = regenerateTokenRes.data.AuthToken;
            if (newAuthToken) {
                getLanguageDropListReq(newAuthToken);
                setIsRegeneratingToken(false); // Reset the flag after successful retry
            }
        }
        if (regenerateTokenRes.loading === false && regenerateTokenRes.data?.status === 'failed' && isRegeneratingToken) {
            // Handle regeneration failure if needed, e.g., show an error to the user
            setIsRegeneratingToken(false); // Reset the flag
            setIsLoading(false); // Stop loading as regeneration failed
            console.error("Token regeneration failed:", regenerateTokenRes.data?.description);
        }
    }, [regenerateTokenRes, dispatch, isRegeneratingToken]);



    // const getLanguageResp = () => {
    //     if (getLanguagesDropRes.data.status === 'success') {
    //         setIsLoading(false);
    //         setLanguageList(getLanguagesDropRes.data.customerMasterDetailsRequestVOList);
    //     }
    //     if (getLanguagesDropRes.data.status === 'failed') {
    //         if (
    //             getLanguagesDropRes.data.description == "session out"
    //         ) {
    //             SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //         if (
    //             getLanguagesDropRes.data.description == "Authorization failed"
    //         ) {
    //             regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //     }
    // }

     // Initial load and token regeneration handling for getLanguageDropListAdmin
    useEffect(() => {
        // Only call if authToken is available and not already regenerating
        if (authToken && !isRegeneratingToken) {
            getLanguageDropListReq(authToken);
        }
    }, [authToken, isRegeneratingToken]); // Depend on authToken and isRegeneratingToken

    // useEffect(() => {
    //     getLanguageResp();
    // },[]);
    //}, [getLanguagesDropRes.data.status]);
    // useEffect(() => {
    //     getLanguageResp();
    // }, [getLanguageName]);

    useEffect(() => {
        getLanguageDropListReq()
    }, [AddLanguageResp ,editMappingLanguageRes.data.status]);

    const addLanguageSubmitReq = () => {
        setAddLanguageResp(true);
        const addLangReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"),

                languageName: addLanguageName,
                languageCode: addLanguageCode,

            }
        }
        dispatch(AdminAddLanguages(addLangReq, authToken));
        setAddOpen(false)
    }

    const addLanguagesRespFunc = () => {
        if (AddLanguageResp) {
            if (addLanguagesRes.data.status === 'success') {
                setRespDescriptionLanguageAddUpdate(addLanguagesRes.data.description)
                setres(addLanguagesRes.data.description);
                setnotificationOpen(true);
                adminGetLanguageListReq();
                getLanguageDropListReq();


            }
            if (addLanguagesRes.data.status === 'failed') {
                setres(addLanguagesRes.data.description);
                setRespDescriptionLanguageAddUpdate(addLanguagesRes.data.description)
                setnotificationOpen(true);
                if (
                    addLanguagesRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    addLanguagesRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }
    useEffect(() => {
        addLanguagesRespFunc()
    //},[]);
    }, [addLanguagesRes.data.status]);


    const adminGetLanguageListReq = () => {
        setIsLoading(true);
        setGetLanguageListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"),
                languageName: selectedLanguage,

            }
        }
        dispatch(getLanguageListAdmin(searchReq, authToken || sessionStorage.getItem("authToken")));

    }

    useEffect(() => {
        // if (regenerateTokenRes.data.status == "success") {
        adminGetLanguageListReq();
        // }
    },[]);
    //}, [regenerateTokenRes.data.status]);



    const adminGetLanguageListFunc = () => {
        if (getLanguageListStatus) {
            if (getLanguageListRes.data.status == "success") {
                setGetLanguageListArray([].concat(getLanguageListRes.data.customerMasterDetailsRequestVOList));
                setIsLoading(false);
                setPage(0);

            }
            if (getLanguageListRes.data.status == "failed") {
                setGetLanguageListArray(getLanguageListRes.data);
                setIsLoading(false);
                if (
                    getLanguageListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getLanguageListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getLanguageListRes.data.status == "NOT FOUND") {
                setGetLanguageListArray(getLanguageListRes.data)
                setIsLoading(false)
            }
        }
    }

    useEffect(() => {
        adminGetLanguageListFunc();
   }, [getLanguageListRes.data.status ]);


    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={5}></Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={() => addLanguageModalOpen()}
                            >
                                Add New Language
                            </CustomButton>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            <NavLink to="/index/adminMappingLanguage">
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}

                                >
                                    Mapping Language
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Language"
                                variant='standard'
                                fullWidth={true}
                                name="selectedLanguage"
                                value={selectedLanguage || ''}
                                onChange={onInputChange}
                            >
                                <MenuItem
                                    value="Select Language"
                                    selected="Select Language"
                                >
                                    Select Language
                                </MenuItem>
                                {getLanguagesDropRes.data.customerMasterDetailsRequestVOList &&
                                    [].concat(getLanguagesDropRes.data.customerMasterDetailsRequestVOList).map((x) => (
                                        <MenuItem key={x.id} value={x.languageName}>
                                            {x.languageName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={adminGetLanguageListReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getLanguageListArray.length == undefined ||
                    !getLanguageListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "5px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}
                                   className="themeText"
                                
                                >
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-2 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                   className="themeText"
                                    
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    ID{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Language Code
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Language Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getLanguageListArray &&
                                                []
                                                    .concat(getLanguageListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                {row.languageCode}
                                                            </TableCell>
                                                            <TableCell align="center">{row.languageName}</TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => editModal(row.id, row.languageName, row.languageCode)}
                                                                >
                                                                    <EditIcon style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>

                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getLanguageListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}
            </Layout>


            <div>
                <Dialog open={addOpen} onClose={handleClose}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Add Language
                    </DialogTitle>
                    <DialogContent>




                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Language Name"
                            fullWidth={true}
                            variant='standard'
                            name="addLanguageName"
                            value={addLanguageName || ""}
                            onChange={onInputChange}
                        ></TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            variant='standard'


                            label="Language Code"
                            fullWidth={true}
                            name="addLanguageCode"
                            value={addLanguageCode || ""}
                            onChange={onInputChange}
                        ></TextField>



                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={addLanguageSubmitReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={editOpen} onClose={closeEditModal}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Edit Language
                    </DialogTitle>
                    <DialogContent>
                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            disabled
                            color="primary"
                            type="text"
                            label="Id"
                            fullWidth={true}
                            name="editBankId"
                            value={editBankId || ""}
                            onChange={editHandleChange}
                        ></TextField> */}
                        <TextField
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            variant='standard'
                            type="text"
                            label="Language code"
                            fullWidth={true}
                            name="editLanguageCode"
                            value={editLanguageCode || ""}
                            onChange={editHandleChange}
                        ></TextField>
                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            variant='standard'

                            label="Language Name"
                            fullWidth={true}
                            name="editLanguageName"
                            value={editLanguageName || ""}
                            onChange={editHandleChange}
                        ></TextField>





                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"

                            onClick={closeEditModal}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"

                            onClick={editSubmitReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>


            {addLanguagesRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionLanguageAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {addLanguagesRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionLanguageAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {editMappingLanguageRes.data.status == "Success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionLanguageAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {editMappingLanguageRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionLanguageAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


        </>
    )
}

export default AdminLanguageMaster